var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.982 11.6246H12.2668L12.0134 11.3801C12.9313 10.3156 13.4357 8.95646 13.4346 7.55082C13.4346 6.38701 13.0895 5.24934 12.443 4.28167C11.7964 3.314 10.8774 2.55979 9.80216 2.11442C8.72694 1.66905 7.5438 1.55252 6.40236 1.77957C5.26091 2.00662 4.21243 2.56705 3.38949 3.38998C2.56656 4.21292 2.00613 5.2614 1.77908 6.40285C1.55204 7.54429 1.66857 8.72743 2.11393 9.80265C2.5593 10.8779 3.31351 11.7969 4.28118 12.4434C5.24885 13.09 6.38652 13.4351 7.55033 13.4351C9.00783 13.4351 10.3476 12.901 11.3797 12.0138L11.6241 12.2673V12.9825L16.1505 17.4998L17.4993 16.151L12.982 11.6246ZM7.55033 11.6246C5.29619 11.6246 3.47658 9.80496 3.47658 7.55082C3.47658 5.29668 5.29619 3.47706 7.55033 3.47706C9.80448 3.47706 11.6241 5.29668 11.6241 7.55082C11.6241 9.80496 9.80448 11.6246 7.55033 11.6246Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.e3f39044fd55caebe7ba8304c4fddd0f.svg";
export { ForwardRef as ReactComponent };